/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ErrorCodeResponse } from '../../models/error-code-response';

export interface MetaErrorCodes$Plain$Params {
}

export function metaErrorCodes$Plain(http: HttpClient, rootUrl: string, params?: MetaErrorCodes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ErrorCodeResponse>>> {
  const rb = new RequestBuilder(rootUrl, metaErrorCodes$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ErrorCodeResponse>>;
    })
  );
}

metaErrorCodes$Plain.PATH = '/api/v1/platform/meta/error-codes';
